import axios from 'axios';
import { Feed } from 'views/self-service/features/feed-catalog/types/feed.type';

// GET FEED
// /ewosapi/v1/shrimps/Feed/{globalSiteId}
export const getFeed = async (globalCompanyId: string, showHidden: boolean = true): Promise<Feed[]> => {
  const res = await axios.get(`/ewosapi/v1/shrimps/Feed/${globalCompanyId}?ShowHidden=${showHidden}`);
  return res.data;
};
